import { ElMessageBox } from "element-plus";
import { accMul } from "@/common/js/utils";
const BaojianOptions = {
  REPORT_NUMBER: "CODE", //报建编号
  INVEST_PROJECT_CODE: "TZ_CODE", //投资项目统一代码
  PROJECT_NAME: "PROJECT_NAME", //项目名称
  PROJECT_TYPE: "PROJECT_TYPE", //工程类别
  ADDRESS: "PROJECT_ADDRESS", //项目地址
  LEGAL_PERSON: "JS_LEGAL_PERSON", //法定代表人(项目法人)
  CONTACTOR: "MANAGER", //项目负责人（联系人）
  CONTACT_INFORMATION: "MANAGER_PHONE", //联系电话
  APPROVAL_NAME: "APPROVAL_NAME", //项目立项或批准文件_文件名称（项目审批文件名称）
  APPROVAL_NUMBER: "APPROVAL_NUMBER", //项目立项或批准文件_文号（项目审批文号）
  APPROVAL_AUTHORITY: "APPROVAL_AUTHORITY", //项目立项或批准文件_发文单位（项目审批单位）
  FUND_SOURCE: "FUND_SOURCE", //资金来源
  TENDER_ORGANIZE_FORM: "TENDER_ORGANIZE_FORM", //招标组织形式
};

// const BaojianOptionsTraffic = {
//   t1871_REPORT_NUMBER: "CODE", //报建编号
//   t1850_INVEST_PROJECT_CODE: "TZ_CODE", //投资项目统一代码
//   t1850_PROJECT_NAME: "PROJECT_NAME", //项目名称  
//   t1850_ADDRESS: "PROJECT_ADDRESS", //项目地址
//   t1850_LEGAL_PERSON: "JS_LEGAL_PERSON", //法定代表人(项目法人)
//   t1850_CONTACTOR: "MANAGER", //项目负责人（联系人）
//   t1850_CONTACT_INFORMATION: "MANAGER_PHONE", //联系电话
//   t1850_APPROVAL_NAME: "APPROVAL_NAME", //项目立项或批准文件_文件名称（项目审批文件名称）
//   t1850_APPROVAL_NUMBER: "APPROVAL_NUMBER", //项目立项或批准文件_文号（项目审批文号）
//   t1850_APPROVAL_AUTHORITY: "APPROVAL_AUTHORITY", //项目立项或批准文件_发文单位（项目审批单位）
//   t1850_FUND_SOURCE: "FUND_SOURCE", //资金来源
//   t1851_TENDER_ORGANIZE_FORM: "TENDER_ORGANIZE_FORM", //招标组织形式
// };

const BaojianOptionsTraffic = {
  REPORT_NUMBER: "CODE", //报建编号
  INVEST_PROJECT_CODE: "TZ_CODE", //投资项目统一代码
  PROJECT_NAME: "PROJECT_NAME", //项目名称  
  ADDRESS: "PROJECT_ADDRESS", //项目地址
  LEGAL_PERSON: "JS_LEGAL_PERSON", //法定代表人(项目法人)
  CONTACTOR: "MANAGER", //项目负责人（联系人）
  CONTACT_INFORMATION: "MANAGER_PHONE", //联系电话
  APPROVAL_NAME: "APPROVAL_NAME", //项目立项或批准文件_文件名称（项目审批文件名称）
  APPROVAL_NUMBER: "APPROVAL_NUMBER", //项目立项或批准文件_文号（项目审批文号）
  APPROVAL_AUTHORITY: "APPROVAL_AUTHORITY", //项目立项或批准文件_发文单位（项目审批单位）
  FUND_SOURCE: "FUND_SOURCE", //资金来源
  TENDER_ORGANIZE_FORM: "TENDER_ORGANIZE_FORM", //招标组织形式
};
const BeianOptions = {
  SJD_TENDER_PROJECT_CODE: "TENDER_PROJECT_CODE", //备案招标项目编号
  RECORD_NUMBER: "REVIEW_CODE", //备案编号
  GGZY_UNIFIED_DEAL_CODE: "UNIFIED_DEAL_CODE", //备案统一交易标识码
};

const BeianOptionsTraffic={
  t1850_RECORD_CODE: "REVIEW_CODE", //备案编号  

};
const ToChangeBaProjectHouse = {
  TENDER_PROJECT: [
    // 备案招标项目（TENDER_PROJECT）数据转换
    "APPROVE_DEPT_CODE",
    "APPROVE_DEPT_NAME",
    "OWNER_NAME",
    "PLATFORM_CODE",
    "PUB_SERVICE_PLAT_CODE",
    "SUPERVISE_DEPT_CODE",
    "SUPERVISE_DEPT_NAME",
    "TENDERER_CODE",
    "TENDERER_CODE_TYPE",
    "TENDERER_NAME",
    "TENDERER_ROLE",
    "TENDER_AGENCY_CODE",
    "TENDER_AGENCY_CODE_TYPE",
    "TENDER_AGENCY_NAME",
    "TENDER_AGENCY_ROLE",
    "TENDER_MODE",
    "TENDER_ORGANIZE_FORM",
    "TENDER_PROJECT_NAME",
    // "TENDER_PROJECT_TYPE",
  ],
  SECTION: [
    // 标段字段
    "BEGIN_DATE",
    "CONTRACT_RECKON_PRICE",
    "CONTROL_PRICE",
    "LIMITE_TIME",
    "CREATE_TIME",
    "PUB_SERVICE_PLAT_CODE",
  ],
  PROJECT: [
    // 备案项目（PROJECT）转换数据
    "ADDRESS",
    "APPROVAL_AUTHORITY",
    "APPROVAL_NAME",
    "APPROVAL_NUMBER",
    "CONTACTOR",
    "CONTACT_INFORMATION",
    "CONTRIBUTION_SCALE",
    "CREATE_TIME",
    "FUND_SOURCE",
    // "INDUSTRIES_TYPE",
    "INVEST_PROJECT_CODE",
    "LEGAL_PERSON",
    "PROJECT_NAME",
    "PROJECT_SCALE",
    "PUB_SERVICE_PLAT_CODE",
    "REGION_CODE",
  ],
};
const ToChangeBaProjectWater = {
  PROJECT: [
    //备案项目（PROJECT）转换数据  'INDUSTRIES_TYPE',
    //   "PROJECT_NAME",
    "REGION_CODE",
    "INVEST_PROJECT_CODE",
    "ADDRESS",
    "LEGAL_PERSON",
    "CONTRIBUTION_SCALE",
    "PROJECT_SCALE",
    "CONTACTOR",
    "CONTACT_INFORMATION",
    "APPROVAL_NAME",
    "APPROVAL_NUMBER",
    "APPROVAL_AUTHORITY",
    "CREATE_TIME",
    "PUB_SERVICE_PLAT_CODE",
  ],
  TENDER_PROJECT: [
    //备案招标项目（TENDER_PROJECT）数据转换    'TENDER_PROJECT_TYPE',
    "TENDER_PROJECT_NAME",
    "OWNER_NAME",
    "TENDERER_NAME",
    "TENDERER_CODE_TYPE",
    "TENDERER_CODE",
    "TENDERER_ROLE",
    "TENDER_AGENCY_NAME",
    "TENDER_AGENCY_CODE_TYPE",
    "TENDER_AGENCY_CODE",
    "TENDER_AGENCY_ROLE",
    "TENDER_MODE",
    "TENDER_ORGANIZE_FORM",
    "SUPERVISE_DEPT_NAME",
    "SUPERVISE_DEPT_CODE",
    "APPROVE_DEPT_NAME",
    "APPROVE_DEPT_CODE",
    "PLATFORM_CODE",
  ],
  SECTION: ["CONTRACT_RECKON_PRICE", "BEGIN_DATE", "LIMITE_TIME", "CONTROL_PRICE"],
};
const ToChangeBaProjectTraffic = {
  PROJECT: [
    //备案项目（PROJECT）转换数据  'INDUSTRIES_TYPE',
    //   "PROJECT_NAME",
    "REGION_CODE",
    "INVEST_PROJECT_CODE",
    "ADDRESS",
    "LEGAL_PERSON",
    "CONTRIBUTION_SCALE",
    "PROJECT_SCALE",
    "CONTACTOR",
    "CONTACT_INFORMATION",
    "APPROVAL_NAME",
    "APPROVAL_NUMBER",
    "APPROVAL_AUTHORITY",
    "CREATE_TIME",
    "PUB_SERVICE_PLAT_CODE",
  ],
  TENDER_PROJECT: [
    //备案招标项目（TENDER_PROJECT）数据转换    'TENDER_PROJECT_TYPE',
    "TENDER_PROJECT_NAME",
    "OWNER_NAME",
    "TENDERER_NAME",
    "TENDERER_CODE_TYPE",
    "TENDERER_CODE",
    "TENDERER_ROLE",
    "TENDER_AGENCY_NAME",
    "TENDER_AGENCY_CODE_TYPE",
    "TENDER_AGENCY_CODE",
    "TENDER_AGENCY_ROLE",
    "TENDER_MODE",
    "TENDER_ORGANIZE_FORM",
    "SUPERVISE_DEPT_NAME",
    "SUPERVISE_DEPT_CODE",
    "APPROVE_DEPT_NAME",
    "APPROVE_DEPT_CODE",
    "PLATFORM_CODE",
  ],
  SECTION: ["CONTRACT_RECKON_PRICE", "BEGIN_DATE", "LIMITE_TIME", "CONTROL_PRICE"],
};

const ToChange = {
  CONTROL_PRICE: "CONTROL_PRICE_Yuan", // 控制价（最高限价）
  LIMITE_TIME: "LIMITE_TIME_Day", // 总工期
};

const ToChangeTime = {
  BEGIN_DATE: "BEGIN_DATE_Format", //计划开工日期
  CREATE_TIME: "CREATE_TIME_Format", //建立时间
};

const ToChangeTraffic = {
  CONTROL_PRICE: "CONTROL_PRICE_Yuan", // 控制价（最高限价）
  LIMITE_TIME: "LIMITE_TIME_Day", // 总工期
  CONTROL_PRICE: "CONTROL_PRICE_Yuan", // 控制价（最高限价）
  LIMITE_TIME: "LIMITE_TIME_Day", // 总工期
}

const setBjData = (form, res, call, state) => {  
  if (__type__ === "traffic") {
    const { TCIDS } = state.config
    const tcids = TCIDS.split(',')
    for (let i in BaojianOptionsTraffic) {
      tcids.forEach(tcid => {
        if (form[`t${tcid}_${i}`] !== undefined) {
          form[`t${tcid}_${i}`] = res[BaojianOptionsTraffic[i]];
        }
      })
    }
  } else{
    for (let i in BaojianOptions) {
      form[i] = res[BaojianOptions[i]];
    }
  }

  
  
  call && call();
};

const setBaData = (form, res, call, state) => {
  if (__type__ === "traffic") {
    BaCallConfig.traffic(form, res, call, state)
  } else {
    BaCallConfig.common(form, res, call)
  }
};

const BaCallConfig = {
  common (form, res, call) {
    let response = JSON.parse(JSON.stringify(res));
    let lastProject = res.PROJECT.pop();
    if (form.REPORT_NUMBER && form.REPORT_NUMBER !== lastProject.CONSTRUCTION_ID) {
      // return ElMessageBox.$alert("请确认报建编号", "提示", {
      //   type: "warning",
      // });
      return ElMessageBox({
        title: "提示",
        type: "warning",
        message: "请确认报建编号",
      });
    }
    res.PROJECT.push(lastProject);
    form.REPORT_NUMBER = lastProject.CONSTRUCTION_ID;
    for (let key in BeianOptions) {
      form[key] = res[BeianOptions[key]];
    }
    let ToChangeBaProject = __type__ == "water" ? ToChangeBaProjectWater : ToChangeBaProjectHouse;
    for (let key in ToChangeBaProject) {
      let last = res[key].pop();
      ToChangeBaProject[key].forEach((_key) => {
        form[_key] = last[_key] || "";
        if (ToChange[_key]) {
          form[_key] = last[ToChange[_key]];
        }
        if (ToChangeTime[_key]) {
          let value = last[ToChangeTime[_key]];
          form[_key] = value ? { $date: new Date(value).getTime() } : "";
        }
      });
    }
    form.CONTROL_PRICE = new Number(form.CONTROL_PRICE).toFixed(2);
    form.PROJECT_NAME_DISABLED = !!lastProject.PROJECT_NAME;
    if (__type__ == "water") {
      /* 项目名称特殊处理都取招标项目名称 */
      form.PROJECT_NAME = form.TENDER_PROJECT_NAME;
      /* 标段合同估算价单位换算 万元换算为元 */
      console.log(response);
      if (response.SECTION[0].PRICE_UNIT == 1) {
        form.CONTRACT_RECKON_PRICE = response.SECTION[0].CONTRACT_RECKON_PRICE ? accMul(response.SECTION[0].CONTRACT_RECKON_PRICE, 10000) : 0;
      }
      form.CONTRACT_RECKON_PRICE = new Number(form.CONTRACT_RECKON_PRICE).toFixed(2);
      form.CONTROL_PRICE = new Number(form.CONTROL_PRICE).toFixed(0);
    }
    call && call();
  },
  traffic (form, res, call, state) {
    let response = JSON.parse(JSON.stringify(res));
    let lastProject = res.PROJECT.pop();
    if (form.t1850_REPORT_NUMBER && form.t1850_REPORT_NUMBER !== lastProject.CONSTRUCTION_ID) {
      // return ElMessageBox.$alert("请确认报建编号", "提示", {
      //   type: "warning",
      // });
      return ElMessageBox({
        title: "提示",
        type: "warning",
        message: "请确认报建编号",
      });
    }
    res.PROJECT.push(lastProject);
    form.t1850_REPORT_NUMBER = lastProject.CONSTRUCTION_ID;
    for (let key in BeianOptions) {
      form[key] = res[BeianOptions[key]];
    }
    const { TCIDS } = state.config
    const tcids = TCIDS.split(',')
    let ToChangeBaProject = ToChangeBaProjectTraffic;
    for (let key in ToChangeBaProject) {
      let last = res[key].pop();
      ToChangeBaProject[key].forEach((_key) => {
        let value = last[_key] || ""
        if (ToChangeTraffic[_key]) {
          value = last[ToChangeTraffic[_key]]
        }
        tcids.forEach(tcid => {
          if (form[`t${tcid}_${_key}`] !== undefined) {
            form[`t${tcid}_${_key}`] = value
          }
        })
      });
    }

    call && call();
  }
}

export default {
  setBjData,
  setBaData,
};
